import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ResidenceSection } from '../ResidenceSection';
import { ReadMore } from '../../ReadMore';

interface DescriptionSectionProps {
  description?: string | null;
}

export const DescriptionSection: React.FC<DescriptionSectionProps> = memo(
  ({ description }) => {
    const { t } = useTranslation();

    return (
      <ResidenceSection title={t('new_ad.description')}>
        <ReadMore description={description} />
      </ResidenceSection>
    );
  }
);

DescriptionSection.displayName = `DescriptionSection`;
